
import { StakeBet } from "../../../../scripts/StakeBet";

class SamuraiBet extends StakeBet{
    constructor( betData = {} ){
        super('samurai')
        this.data = {... this.data, ... betData}

        this.nSteps = 0
    }

    async next(){

        let [err, result] = await this.step("next", {identifier: "samurai_"+ Date.now() })

        return [err,  this.data]
    }

    async bet(betConfig){
        if(betConfig)
         this.betConfig =  {... this.betConfig, ... betConfig }

        let [err, result] = await this.step("bet", this.betConfig)

        return [ err, this.data]
    }

    async step(action, variables = {}){
        try {
        
        if(super[action] && typeof super[action] === "function"){
            let step_result = await super[action](variables)

            if(step_result.errors)
                return [step_result.errors, null]

            this.nSteps++
            
            if(!this.data?.active)
                this.done(this.data)

            return [null, step_result.data]         
        }

        }
        catch(err){
            console.log("[Error] SamuraiBet fnc step: ")
             console.error(err)
             return [err, null]
        }

    }

    done(betResult){
        if(this._resultResolve)
        this._resultResolve(betResult)
    }

    result(){
        return new Promise((resolve,reject) =>{
        this._resultResolve = resolve
        this._resultReject = reject

        })
    }

}

export { SamuraiBet }

